// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"37":"4ef86c6e","313":"fac65e11","531":"adc00def","836":"ecc1d85e","967":"12e22f7c"}[chunkId] + ".js";
};